<template>
  <div class="dashboard-block">
    <h2>Share Your Profile</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <p>Your followers want to know that you're available to book. Share your profile on your socials.</p>
        <div class="flex">
          <input
            class="w-full margin-r-1"
            ref="copy_input"
            type="text"
            id="copy_input"
            name="copy_input"
            v-model="user.social_share_link"
            readonly="readonly"
          >
          <button @submit.prevent class="btn btn-primary pull-right" @click="handleCopySocialLink" @mouseout="() => {this.copied = false}">
            {{ tooltipText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],

  data () {
    return {
      copied: false
    }
  },

  computed: {
    ...mapState('user', ['user']),

    tooltipText () {
      if (this.copied) {
        return 'Copied ✓'
      } else {
        return 'Copy'
      }
    }
  },

  methods: {
    handleCopySocialLink () {
      const copyInput = this.$refs.copy_input
      copyInput.select()
      copyInput.setSelectionRange(0, 1000)
      document.execCommand('copy')
      this.copied = true
      this.trackEvent(this.analytics.V2.ShareUrlClickEvent)
    }
  }
}
</script>
